import dynamic from 'next/dynamic';

const BottomNavigationBar = dynamic(import('./BottomNavigationBar'), { ssr: false });

export default BottomNavigationBar;